import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import firebase from 'firebase/app';

import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/analytics';

export interface FirebaseContextData {
  firestore: firebase.firestore.Firestore,
  auth: firebase.auth.Auth,
  analytics: firebase.analytics.Analytics,
};

firebase.initializeApp({
  apiKey: "AIzaSyDJU3YhUQC4jQYYLGmEDHsW_n8dPpNIoy8",
  authDomain: "readlist-6d595.firebaseapp.com",
  projectId: "readlist-6d595",
  storageBucket: "readlist-6d595.appspot.com",
  messagingSenderId: "703202442113",
  appId: "1:703202442113:web:a2fb9603a8936438df4680",
  measurementId: "G-RDYHEZPGGM"
});

const auth = firebase.auth();
const firestore = firebase.firestore();
const analytics = firebase.analytics();
const firebaseContextData: FirebaseContextData = { firestore, auth, analytics };

export const FirebaseContext = React.createContext<FirebaseContextData>(firebaseContextData);

ReactDOM.render(
  <React.StrictMode>
    <FirebaseContext.Provider value={ firebaseContextData } >
      <App />
    </FirebaseContext.Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
